var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"selected-column",style:({ left: (_vm.left + "px") })}),_c('div',{staticClass:"selected-column",style:({ left: ((_vm.left + _vm.width) + "px") })})])}
var staticRenderFns = []

export { render, staticRenderFns }